import { styled } from 'styled-components';

export const FieldWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  column-gap: 8px;
`;
